import { render } from "./PointHistories.vue?vue&type=template&id=0779f481&scoped=true"
import script from "./PointHistories.vue?vue&type=script&lang=js"
export * from "./PointHistories.vue?vue&type=script&lang=js"

import "./PointHistories.vue?vue&type=style&index=0&id=0779f481&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0779f481"

export default script